/*
 * @Author: cloud
 * @Date: 2020-12-28 10:34:39
 * @Last Modified by: cloud
 * @Last Modified time: 2021-04-13 10:37:46
 */

import eventBus from '@/utils/eventBus.js'
import router from '@/router'
import axios from 'axios'
// import { appLogin } from './jsbridge'
// import { getCookie } from './cookie'
// import { Toast, Loading } from 'vue-ydui/dist/lib.rem/dialog';
// 创建axios实例
// import Cookies from 'js-cookie'
const redirectLogin = () => {
  const forword = window.location.href.split('#')[1]
  if (forword.indexOf('login') === -1) {
    // 防止重复跳转到登录页面
    router.replace({
      path: '/login',
      query: {
        forword: forword
      }
    })
    localStorage.setItem('token', '')
    eventBus.$emit('outLogin', 2)
  }
}
window._apiUrls = window._apiUrls || {}
window.__baseUrl__ =
  process.env.NODE_ENV == "production"
    ? window._apiUrls.baseUrl
    : process.env.NODE_ENV == "test"
      ? window._apiUrls.test
      : window._apiUrls.dev
// console.log(window.__baseUrl__, 'window.__baseUrl__')
const service = axios.create({
  // baseURL: process.env.VUE_APP_BASE_URL, // api 的 base_url
  baseURL: window.__baseUrl__,

  // timeout: 15000 // 请求超时时间
})
// const service = axios.create({
//   // baseURL: process.env.VUE_APP_BASE_URL, // api 的 base_url
//   // baseURL: 'http://47.106.169.20:8084/api-biz', // api 的 base_url
//   baseURL: 'http://47.94.86.78:8084/api-biz',
//   timeout: 500000 // 请求超时时间
// })
// request拦截器
service.interceptors.request.use(
  config => {
    // if (config.token) {
    //   let token = localStorage.getItem('token')
    //   if (!token) {
    //     redirectLogin()
    //   }
    //   config.headers.Authorization = token
    // }
    let token = localStorage.getItem("token")

    if (token) {
      config.headers.Authorization = token
    }
    return config
  },
  error => {
    // Do something with request error
    Promise.reject(error)
  }
)
// response 拦截器
service.interceptors.response.use(
  response => {
    if (response.data.code === 401) {
      redirectLogin()
    }
    /**
     * code为非20000是抛错 可结合自己业务进行修改
     */
    return response.data
  },
  error => {
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js